import { RecordingPanelHost } from "@msuite/ui/video-recorder";
import { useNavigate } from "react-router";

/**
 * The application's mount for the recording surface. It exists only to hand the panel a way
 * back to the page a recording belongs to: `@msuite/ui` knows that destination as a link and
 * has no router of its own.
 */
export function RecordingPanel() {
	/** Hooks */
	const navigate = useNavigate();

	/** Render */
	return <RecordingPanelHost onOpenTarget={(href) => navigate(href)} />;
}
